import { flow } from 'lodash/fp';
import { forIn, take, union, without } from 'lodash';
import { DRAG_AND_DROP_CONSTANTS } from './constants';

export const reorderMultiDrag = (args) => {
	const { entities, selectedPages, pageIdsSelected, draggableId, destination } = args;

	const pagesToReorder = entities.columns[destination.droppableId].pageIds;
	const orderedSelectedPageIds =
		destination.index < 1
			? union([draggableId], pageIdsSelected, pagesToReorder)
			: flow(
					(arr) => take(arr, destination.index),
					(arr) => without(arr, ...pageIdsSelected),
					(arr) => union(arr, [draggableId], pageIdsSelected, pagesToReorder)
			  )(pagesToReorder);

	let updatedData = { ...entities };

	forIn(selectedPages, (values, columnId) => {
		if (columnId === destination.droppableId) return;

		const { pageIds } = entities.columns[columnId];

		if (pageIds.length === values.length && columnId !== DRAG_AND_DROP_CONSTANTS.UNORDERED_TYPE) {
			// delete empty column
			const { [columnId]: columnToFilter, ...restColumns } = updatedData.columns;
			const columnOrder = without(updatedData.columnOrder, columnId);

			return (updatedData = {
				...updatedData,
				columns: restColumns,
				columnOrder,
			});
		}

		const filtredPages = without(updatedData.columns[columnId].pageIds, ...values);

		updatedData = {
			...updatedData,
			columns: {
				...updatedData.columns,
				[columnId]: {
					...updatedData.columns[columnId],
					pageIds: filtredPages,
				},
			},
		};
	});

	updatedData = {
		...updatedData,
		columns: {
			...updatedData.columns,
			[destination.droppableId]: {
				...updatedData.columns[destination.droppableId],
				pageIds: orderedSelectedPageIds,
			},
		},
	};

	return { updatedData, orderedSelectedPageIds: { [destination.droppableId]: pageIdsSelected } };
};
